var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12"},[_c('div',{staticClass:"card h-100"},[_c('PqParticipants')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }